import React from 'react';
import '../CSS/TopperCard.css';

const TopperCard = ({ topper }) => {
  const { name, percentage, course, year, imageURL, school } = topper;
  return (
    <article className="ngt-topper-card">
      {imageURL
        ? <img src={imageURL} alt={name} loading="lazy" />
        : <div className="tc-placeholder"><i className="fas fa-user-graduate"></i></div>
      }
      <h6>{name}</h6>
      <div className="tc-percent">{percentage}%</div>
      <div className="tc-course">{course}{year ? ` · ${year}` : ''}</div>
      {school && <div className="tc-school"><i className="fas fa-school"></i> {school}</div>}
    </article>
  );
};

export default TopperCard;